<div class="implants-list--container position-relative">
    <div class="table-container">
        <div class="table-top-wrapper mb-3">
            <div class="flex-container gap-2">
                <div class="flex-container justify-content-center p-2 cursor-pointer" (click)="goBack()">
                    <img class="back-arrow" src="../../../assets/images/back_arrow.png" alt="" srcset="">
                </div>
                <div>
                    <h2 class="header-2 text-start mb-1 text-capitalize">Total {{ implantType }} Implants: {{ totalImplants }}</h2>
                    <h6 class="text-default text-start text-dark">{{ storeDetails?.name ? storeDetails.name : '-- --' }}</h6>
                </div>
            </div>
            <div *ngIf="isImplantProducts" class="search-controls">
                <form action="" class="search-block" (submit)="onSearchSubmit()">
                    <div class="search-input">
                        <input type="text" [(ngModel)]="searchInput" name="search" placeholder="Search by Product name and batch number">
                    </div>
                    <button type="submit" class="icon-btn">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.2513 12.9228L16.8527 14.5242C17.4953 15.1668 17.4953 16.2086 16.8527 16.8512C16.2101 17.4938 15.1683 17.4938 14.5257 16.8512L12.9243 15.2498M0.667969 7.74984C0.667969 3.83782 3.83929 0.666504 7.7513 0.666504C11.6633 0.666504 14.8346 3.83782 14.8346 7.74984C14.8346 11.6619 11.6633 14.8332 7.7513 14.8332C3.83929 14.8332 0.667969 11.6619 0.667969 7.74984Z" stroke="white" stroke-width="1.25" stroke-linecap="round"/>
                        </svg>                            
                    </button>
                </form>
                <button type="button" class="reset-btn" (click)="reset($event)">
                    Reset
                </button>
                <button class="export-btn" (click)="downloadImpants()">
                    <i class="export-icon"></i>
                    Export
                </button>
            </div>
        </div>

        <div *ngIf="isImplantProducts" class="table-wrapper table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th class="" scope="col">Product Code</th>
                        <th class="" scope="col">Product name</th>
                        <th class="" scope="col">Batch Number</th>
                        <th class="" scope="col">
                            Expiry Date
                            <span (click)="expirySort()">
                                <img class="sort-img" src="../../../../assets/images/table/sort.png" alt="">
                            </span>
                        </th>
                        <th *ngIf="implantType !== 'consumed' && implantType !== 'low_stocks'" class="position-relative" scope="col">
                            Cabinet
                            <span (click)="openCabinetsPopup($event)">
                                <img *ngIf="selectedCabinetNames.length === 0" class="sort-img" src="../../../../assets/images/dropdown.png" alt="">
                                <img *ngIf="selectedCabinetNames.length !== 0" class="ms-1" src="../../../../assets/images/check.svg" alt="" srcset="">
                            </span>
                            <div class="popup" id="cabinets-popup">
                                <form>
                                    <div class="form-group">
                                      <input name="cabinet" id="at_store" type="checkbox" value="at_store" [checked]="selectedCabinetNames.includes('at_store') ? true : false" (change)="onCabinetFilterChange($event)">
                                      <label for="at_store">At Store</label>
                                    </div>
                                    <div class="form-group" *ngFor="let cabinet of cabinetNamesList">
                                      <input name="cabinet" [id]="cabinet.u_name" type="checkbox" [value]="cabinet.id" [checked]="selectedCabinetNames.includes(cabinet.id.toString()) ? true : false" (change)="onCabinetFilterChange($event)">
                                      <label [for]="cabinet.u_name">{{ cabinet.u_name }}</label>
                                    </div>
                                </form>
                            </div> 
                        </th>
                        <th *ngIf="implantType == 'low_stocks'" class="position-relative" scope="col">Stocks</th>
                        <th class="position-relative" scope="col">
                            {{ implantType !== 'consumed' ? 'Last Updated' : 'Consumed Date' }}
                        </th>
                        <th class="" scope="col" *ngIf="implantType !== 'low_stocks'"></th>
                    </tr> 
                </thead>
                <tbody *ngIf="isFilterResult">
                    <tr *ngFor="let product of implantProducts" (click)=" (implantType !== 'low_stocks') ? openDialog(product.store_id, product.product_stock_id) : openLowStockDialog(storeId,product.id)">
                        <th>{{ product.product_code }}</th>
                        <td>{{ product.name }}</td>
                        <td>{{ product.batch_no || product.batch_number || product.batchNumber || product.batch || 'N/A' }}</td>
                        <td>{{ product.expiry_date }}</td>
                        <td *ngIf="implantType !== 'consumed' && implantType !== 'low_stocks'">
                            <a [routerLink]="'/home/stocks/cabinets/' + product.cabinet_id" class="text-decoration-underline" *ngIf="product.cabinet_name">{{ product.cabinet_name.substring(0, 15) + '...' }}</a>
                            <span *ngIf="!product.cabinet_name">At Store</span>
                        </td>
                        <td *ngIf="implantType == 'low_stocks'">{{ product.stock_qty }}
                        </td>
                        <td>{{ product.last_updated_at }}</td>
                        <td class="text-center position-relative" (click)="openPopup($event)" *ngIf="implantType !== 'low_stocks'">
                            <span>
                                <img class="icon-xs" src="../../../assets/images/table/three_dots.png" alt="dots">
                            </span>
                            <div id="dots-popup" class="dots-popup">
                                <ul>
                                    <li *ngIf="this.implantType !== 'consumed'" (click)="openConsumeDialog(storeId, product.product_stock_id, product.name)">Mark as consume</li>
                                    <li *ngIf="this.implantType === 'consumed'" (click)="openResetStatusDialog(storeId, product.product_stock_id, product.name)">Reset Status</li>
                                </ul>
                            </div>   
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="!isFilterResult">
                    <td colspan="6">
                        <div class="p-3 no-record text-center flex-container flex-column justify-content-center">
                            <img src="../../../../assets/images/table/filter_empty_screen.svg" alt="" srcset="">
                            <h2 class="header-2 mb-2">No records were found matching your search</h2>
                        </div>
                    </td>
                </tbody>
            </table>
        </div>

        <div class="" *ngIf="totalPages > 1 && isImplantProducts">
            <app-pagination [totalPages]="totalPages" (queryPage)="getQueryPage($event)"></app-pagination>
        </div>
    </div>
    <div *ngIf="!isImplantProducts" class="p-3 m-3 text-center flex-container flex-column justify-content-center">
        <img src="../../../../assets/images/table/empty_cabinet_summary.svg" alt="" srcset="">
        <h2 class="header-2 mb-2">No records available to view</h2>
    </div>
    <app-toast-message></app-toast-message>
</div>